import { apiFetch } from './client';

export async function getMasteryStudentOverview(studentId) {
  return apiFetch(`/analytics/mastery/students/${studentId}`);
}

export async function getMasterySkillTimeline(studentId, skillId, { limit = 50 } = {}) {
  return apiFetch(`/analytics/mastery/students/${studentId}/skills/${skillId}/timeline?limit=${limit}`);
}

export async function getMasteryProgressionSummary(studentId, { hours = 168, limit = 500 } = {}) {
  return apiFetch(
    `/analytics/mastery/students/${studentId}/progression-summary?hours=${hours}&limit=${limit}`
  );
}
